import client from '../config/AxiosConfig';

export const GetConfigs = async () => await client.get('/configs');

export const GetConfig = async (id) => await client.get(`/configs/${id}`);

export const UpdateConfigType = async (id, data) => await client.put(`/configs/${id}`, data);